// extracted by mini-css-extract-plugin
var _1 = "Text_body__xK+1I";
var _2 = "Text_bodyLg__HMLYs";
var _3 = "Text_caption__KYbH5";
var _4 = "Text_colorAccent__Rqlqb";
var _5 = "Text_colorDanger__Dfy0Q";
var _6 = "Text_colorInverse__805Og";
var _7 = "Text_colorPrimary__1xibG";
var _8 = "Text_colorSecondary__1w3a7";
var _9 = "Text_colorSuccess__xvjhD";
var _a = "Text_colorTertiary__w68Ct";
var _b = "Text_display__lJckK";
var _c = "Text_heading__F94Rv";
var _d = "Text_label__VzJ7A";
var _e = "Text_mono__bkJlG";
var _f = "Text_subheading__o5TG6";
var _10 = "Text_text__GZt49";
var _11 = "Text_title__63sfm";
var _12 = "Text_truncate__m3EnW";
var _13 = "Text_weightBold__OkSuP";
var _14 = "Text_weightMedium__KSXK-";
var _15 = "Text_weightRegular__PoZqY";
var _16 = "Text_weightSemibold__5agzN";
export { _1 as "body", _2 as "bodyLg", _3 as "caption", _4 as "colorAccent", _5 as "colorDanger", _6 as "colorInverse", _7 as "colorPrimary", _8 as "colorSecondary", _9 as "colorSuccess", _a as "colorTertiary", _b as "display", _c as "heading", _d as "label", _e as "mono", _f as "subheading", _10 as "text", _11 as "title", _12 as "truncate", _13 as "weightBold", _14 as "weightMedium", _15 as "weightRegular", _16 as "weightSemibold" }
